import { SelectProps, TextField } from "@mui/material";
import React from "react";

interface DropDownRequiredProps {
  codes: string[];
  elementId: string;
  value: string;
}

interface DropDownOptionalProps {
  defaultValue?: string;
  disable?: boolean;
  label?: string;
  name?: string;
  onChange?: any;
  className?: string;
  inputProps?: Partial<SelectProps["inputProps"]>;
  defaultOption?: string;
}

interface DropDownProps extends DropDownRequiredProps, DropDownOptionalProps {}

const defaultProps: DropDownOptionalProps = {
  defaultValue: "",
  disable: false,
  label: "",
  name: "",
  onChange: "",
  className: "form-control",
  inputProps: {},
  defaultOption: "",
};

export const DropDown: React.FC<DropDownProps> = ({
  codes,
  defaultValue,
  elementId,
  disable,
  label,
  className,
  name,
  onChange,
  inputProps,
  value,
  defaultOption,
}) => {
  return (
    <>
      <TextField
        className={className}
        id={elementId}
        label={label}
        name={name}
        {...(value !== undefined && value !== "null" && { value: value })}
        select
        onChange={onChange}
        SelectProps={{
          native: true,
        }}
        inputProps={{ ...inputProps, defaultValue: defaultValue }}
        InputLabelProps={{
          shrink: true,
        }}
        disabled={disable}
      >
        {defaultOption !== "" ? (
          <option key={""} value={""}>
            {defaultOption}
          </option>
        ) : (
          ""
        )}
        {codes?.map((code) => (
          <option key={code} value={code}>
            {code}
          </option>
        ))}
      </TextField>
    </>
  );
};

DropDown.defaultProps = defaultProps;
